<template>
  <div v-click-outside="onClickOutside" id="box--imdb">
    <div class="submenu--item" @click="openRange()">
      IMDB Rating
      <font-awesome-icon class="submenu--icon" icon="chevron-down" />
    </div>
    <div class="box--imdb">
      <div class="box--imdb--triangulo"></div>
      <div class="header--imdb">
        <span class="imdb--title">Movies</span>
        <span class="imdb--reset" @click="closeRange()">X Reset</span>
      </div>
      <div class="range--imdb">
        <div>
          <img
            class="icon--imdb"
            src="../../../assets/imdb.png"
            alt="IMBD logo"
          />
        </div>
        <div>
          <vue-slider
            :min="0"
            :max="10"
            :interval="0.5"
            :tooltip="tooltip"
            :process-style="{ backgroundColor: '#94C659' }"
            :tooltip-style="{
              backgroundColor: '#94C659',
              borderColor: '#94C659',
            }"
            :dot-style="{
              borderColor: '#94C659',
            }"
            class="input"
            v-model="value"
          >
          </vue-slider>
        </div>
        <!-- <div>{{ value }}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

export default {
  components: {
    VueSlider,
  },
  data: () => ({
    tooltip: "none",
    value: [3, 10],
    delayTimer: "",
  }),
  watch: {
    value() {
      clearTimeout(this.delayTimer);
      let params = {
        data: this.value.toString(),
        src: this.$route.name,
      };
      this.delayTimer = setTimeout(() => {
        this.$store.dispatch("FETCH_EDIT_IMDB", params);
      }, 2000);
    },
  },
  methods: {
    onClickOutside() {
      let el = document.getElementsByClassName("box--imdb");
      el[0].classList.remove("menu-visible");
      if (this.tooltip == "always") this.tooltip = "none";
    },

    openRange() {
      let el = document.getElementsByClassName("box--imdb");
      el[0].classList.toggle("menu-visible");
      if (this.tooltip == "always") this.tooltip = "none";
      else this.tooltip = "always";
    },
    closeRange() {
      this.value = [3, 10];
    },
  },
};
</script>

<style scoped>
.submenu--item {
  color: #d5d5d5;
  font-size: 15px;
  cursor: pointer;
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
}
.submenu--icon {
  font-weight: thin;
  padding-left: 10px;
  align-self: end;
}

.box--imdb--triangulo {
  position: absolute;
  width: 20px;
  height: 10px;
  top: -8px;
  left: 40px;
  background: #1c2531;

  /* The points are: centered top, left bottom, right bottom */
  clip-path: polygon(50% 0, 0 100%, 100% 100%);
}
.box--imdb {
  background-color: #1c2531;
  color: #d5d5d5;
  font-size: 0.8em;
  padding: 4px 10px 15px 10px;
  position: absolute;
  z-index: 9000;
  margin-top: 10px;
  margin-left: 0px;
  visibility: hidden;
  width: 280px;
}
.menu-visible {
  visibility: visible;
}
.range--imdb {
  width: 280px;
  display: grid;
  grid-template-columns: 50px 220px 0px;
}
.range--imdb > div {
  padding: 5px;
  font-size: 1em;
}

.icon--imdb {
  width: 40px;
}

.header--imdb {
  display: flex;
  justify-content: space-between;
  align-items: top;
}
.imdb--title {
  color: white;
  font-size: 1.3em;
  padding-bottom: 10px;
  padding-left: 15px;
}
.imdb--reset {
  padding-top: 1px;
}

.input {
  width: 100px;
}

@media (min-width: 600px) and (max-width: 960px) {
  .submenu--item {
    font-size: 0.75em;
  }
}
@media (max-width: 600px) {
  .submenu--item {
    font-size: 0.6em;
  }
  .box--imdb {
    width: 90vw;
  }
}
</style>
